module.exports = __webpack_public_path__ + "media/images/acnt-banner-bg-40bc576d47ea23bfa97826229cd75e03.png";